/*
  The product rating's link to the reviews. It finds the reviews on the page (the widget of the reviews app, else the
  Reviews row), opens the row or selects the tab that holds them, and scrolls to its title. Without this script, or
  when the page has no reviews, the link follows its in-page address.
*/

if (!customElements.get('review-link')) {
  const WIDGETS = '#judgeme_product_reviews, .jdgm-review-widget, [id^="Reviews-"]';

  customElements.define(
    'review-link',
    class ReviewLink extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.querySelector('a')?.addEventListener('click', (event) => this.onClick(event), {
          signal: this.controller.signal,
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onClick(event) {
        const target = document.querySelector(WIDGETS);
        if (!target) return;
        event.preventDefault();
        const row = target.closest('.product-page__row') ?? target;
        const details = row.querySelector('details') ?? target.closest('details');
        row.closest('tab-set')?.show?.(row);
        if (details) details.open = true;
        const summary = details?.querySelector('summary');
        // In tabs, the row's own title is hidden: the row itself is the place to go.
        const title = summary?.offsetParent ? summary : row;
        title.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
        if (title === summary) summary.focus({ preventScroll: true });
      }
    }
  );
}
